import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { CustomerContext } from "~/hooks/use-customer";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

export type Customer = RouterOutputs["customer"]["getCustomers"][number];

interface CustomerProviderProps {
  children: ReactNode;
}

export const CustomerProvider = ({ children }: CustomerProviderProps) => {
  const { data: customers, isFetching: isCustomersLoading } =
    api.customer.getCustomers.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isCustomersLoading) {
      setLoadingStage("buttons");
    } else {
      setLoadingStage(undefined);
    }
  }, [isCustomersLoading, setLoadingStage]);

  const context = {
    customers,
  };

  return (
    <CustomerContext.Provider value={context}>
      {children}
    </CustomerContext.Provider>
  );
};
